import { ZealApiSuccessResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IGetRecentlyViewedPagesArgs,
  IGetRecentlyViewedPagesResponseData,
} from "./getRecentlyViewedPages.schema";

type SuccessResponse =
  ZealApiSuccessResponse<IGetRecentlyViewedPagesResponseData>;

export const getRecentlyViewedPages = (axios: IAxiosInstance) => {
  return async (params: IGetRecentlyViewedPagesArgs) => {
    try {
      const response = await axios.noRetry.get<SuccessResponse>(
        "/api/recently-viewed-pages",
        { params }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
